// removed by extract-text-webpack-plugin
module.exports = {"button":"button_1iXTg","successMessage":"successMessage_2OX9g","errorMessage":"errorMessage_1VT0A","loader":"loader_1qWDL"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/PageResetCgn/style.css
// module id = 194
// module chunks = 0